import createWrappedField from './createWrappedField'
import IS from 'components/Search/IndexSearch'

export default createWrappedField({
  Component: IS,
  name: 'DDIIndexSearch'
})
